<form class="forget-form">
    <h3 class="login-head"><i class="fa fa-lg fa-fw fa-lock"></i>Forgot Password ?</h3>
    <div class="form-group">
      <label class="control-label">EMAIL</label>
      <input class="form-control" type="text" placeholder="Email">
    </div>
    <div class="form-group btn-container">
      <button class="btn btn-primary btn-block"><i class="fa fa-unlock fa-lg fa-fw"></i>RESET</button>
    </div>
    <div class="form-group mt-3">
      <p class="semibold-text mb-0"><a [routerLink]="[ '/account/login' ]" data-toggle="flip"><i class="fa fa-angle-left fa-fw"></i> Back to Login</a></p>
    </div>
  </form>

